<template>
<div>
    <Breadcrumbs main="Procuremnet" submain="Create" title="Purchase Requisition" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Title <span style="color: red;">*</span></label>
                                        <input class="form-control" type="text" placeholder="Enter requisition title" v-model="requisition.title" style="height: 44px;">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Department</label>
                                        <v-select class="custom-vue-select" :options="department_list" label="name" :reduce="dept => dept.id" v-model="requisition.department" placeholder="Select a project"></v-select>
                                    </div>
                                </div>
                            </div>
                           
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Items</label>
                                        <ItemTable style="margin-bottom: 10px;" id="item-table" @itemsUpdated="updateItems" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-4"></div>
                                <div class="col-sm-8">
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Grand Total</label>
                                        <input class="form-control" type="number" placeholder="Enter grand total" v-model="total" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Purpose</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter purpose..." rows="2" v-model="requisition.purpose"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Create</button>
                                        <router-link to="/procurement/purchase-requisition">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    computed
} from "vue";
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import ItemTable from "./item-table.vue";
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        ItemTable,
        Multiselect,
        'v-select': vSelect
    },

    data() {
        return {
            editor: ClassicEditor,
            isDisabled: false,
            requisition: {
                title: '',
                department: null,
                items: [],
                purpose: null
            },
            total: computed(() => {
                let total = 0;
                if (this.requisition.items.length >= 1) {
                    this.requisition.items.map((item) => {
                        total = total + item.estimated_total;
                    });
                }
                return total;
            }),
            // grand_total: computed(() => {
            //     if (this.total !== 0) {
            //         let gtotal =
            //             this.total +
            //             tax * (this.total / 100) -
            //             discount * (this.total / 100);
            //         return Math.round((gtotal + Number.EPSILON) * 100) / 100;
            //     }
            //     return 0;
            // }),

        }
    },

    computed: {
        ...mapState({
            department_list: state => state.department.departments,
        })
    },

    mounted() {
        this.$store.dispatch("department/fetchDepartments");
    },

    methods: {
        updateItems(data) {
            if (data) {
                this.requisition.items = data;
            }
        },

        onSubmit() {
            this.isDisabled = true,

            this.requisition.title = this.requisition.title.trim() ? this.requisition.title : null;

           
            this.$store.dispatch("purchaseRequisition/addPurchaseRequisition", this.requisition).then(response => {
                console.log(response)
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.requisition.title = ''
                    this.requisition.department = null
                    this.requisition.items = []
                    this.requisition.purpose = null
                  

                    

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            setTimeout(() => this.$router.push('/procurement/purchase-requisition'), 2000)
            

            this.isDisabled = false
        },

        

      
    }
};
</script>
